import React, { useCallback, useEffect, useState } from 'react';
import cogoToast from 'cogo-toast';

import {
  useDeleteSbatGroupLectureContentMutation,
  useGetSbatGroupQuery,
} from 'features/classCreation';
import CreateLectureContentModal from '../CreateLectureContentModal';
import ToggleChip from 'components/ToggleChip';

function findByContentType(lectureContents, contentType) {
  return lectureContents?.find(
    (lectureContent) => lectureContent.content_type === contentType
  );
}

export default function SbatGroupLectureContentChip({
  sbatGroup,
  contentType,
  title,
}) {
  const [modalOpen, setModalOpen] = useState(false);
  const [deleteLectureContent, { isSuccess, error }] =
    useDeleteSbatGroupLectureContentMutation();

  const { sbatGroupLectureContent } = useGetSbatGroupQuery(sbatGroup.id, {
    selectFromResult: ({ data }) => ({
      sbatGroupLectureContent: findByContentType(
        data?.data?.academy_topic.lecture_contents,
        contentType
      ),
    }),
  });

  const handleModalOpen = useCallback(() => {
    setModalOpen(true);
  }, []);

  const handleModalClose = useCallback(() => {
    setModalOpen(false);
  }, []);

  useEffect(() => {
    if (isSuccess) {
      cogoToast.success('Lecture content is successfully deleted!');
    }
    if (error) {
      cogoToast.error(
        error?.data?.message ||
          'There was some problem in deleting the lecture content. Please try again later!'
      );
    }
  }, [error, isSuccess]);

  const handleContentDelete = useCallback(() => {
    if (
      window.confirm('Are you sure, you want to delete this lecture content?')
    ) {
      deleteLectureContent({
        lectureContentId: sbatGroupLectureContent?.id,
        sbatGroupId: sbatGroup.id,
      });
    }
  }, [deleteLectureContent, sbatGroup.id, sbatGroupLectureContent?.id]);

  return (
    <>
      <CreateLectureContentModal
        title={title}
        handleClose={handleModalClose}
        contentType={contentType}
        sbatGroup={sbatGroup}
        isOpen={modalOpen}
      />
      <ToggleChip
        isAdded={Boolean(sbatGroupLectureContent)}
        onAdd={handleModalOpen}
        onRemove={handleContentDelete}
        label={title}
        className="m-r-xs m-b-xxs"
      />
    </>
  );
}
